import { api } from '@/app/_utils/apiClient';
import {
  ChangePasswordRequestType,
  FindPasswordRequestType,
  LoggedInfoResponseType,
  LoginRequestType,
  LoginResponseType,
  ResetPasswordRequestType,
  SignUpRequestType,
  UpdateMemberRequestType,
} from '@/app/_types/api/memberServiceType';

class MemberService {
  private serviceUrl = '/api/member/v1';

  async postLogin(emailAddress: string, password: string) {
    return await api.post<LoginRequestType, LoginResponseType>(`${this.serviceUrl}/login`, {
      email_address: emailAddress,
      password,
    });
  }

  // 로그인 정보, 추후 대시보드 생성 시 필요할 수 있음.
  async getLoggedInfo() {
    return await api.get<LoggedInfoResponseType>(`${this.serviceUrl}/logged-info`);
  }

  async postLogout() {
    return await api.post(`${this.serviceUrl}/logout`);
  }

  async postSignUp(
    emailAddress: string,
    password: string,
    userName: string,
    position: string,
    company: string,
    privacyAgreementSelect: boolean,
    acceptAgreement: 'Y' | 'N',
  ) {
    return await api.post<SignUpRequestType>(`${this.serviceUrl}/sign-up`, {
      email_address: emailAddress,
      password,
      user_name: userName,
      position,
      company,
      private_agreement_select: privacyAgreementSelect,
      accept_agreement: acceptAgreement,
    });
  }

  async postUpdateMember(
    company: string,
    position: string,
    userName: string,
    privateAgreementSelect: boolean,
  ) {
    return await api.post<UpdateMemberRequestType>(`${this.serviceUrl}/update-member`, {
      company,
      position,
      user_name: userName,
      private_agreement_select: privateAgreementSelect,
    });
  }

  async postChangePassword(password: string, confirmPassword: string) {
    return await api.post<ChangePasswordRequestType>(`${this.serviceUrl}/change-password`, {
      password,
      confirm_password: confirmPassword,
    });
  }

  async postFindPassword(emailAddress: string) {
    return await api.post<FindPasswordRequestType>(`${this.serviceUrl}/find-password`, {
      email_address: emailAddress,
    });
  }

  async postResetPassword(
    memberSrl: number,
    authKey: string,
    password: string,
    confirmPassword: string,
  ) {
    return await api.post<ResetPasswordRequestType>(`${this.serviceUrl}/reset-password`, {
      member_srl: memberSrl,
      auth_key: authKey,
      password,
      confirm_password: confirmPassword,
    });
  }

  async postMemberLeave(password: string) {
    return await api.post(`${this.serviceUrl}/member-leave`, { password });
  }

  async postResendAuthEmail(emailAddress: string) {
    return await api.post(`${this.serviceUrl}/resend-auth-email`, {
      email_address: emailAddress,
    });
  }

  async postAuthEmail(memberSrl: number, authKey: string) {
    return await api.post(`${this.serviceUrl}/auth-email`, {
      member_srl: memberSrl,
      auth_key: authKey,
    });
  }
}

export default new MemberService();
